export function getFormattedPrice(price) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(price);
}

export function calculateTotalBill(services) {
    const values = [];
    services.map((service) => {
        return values.push(+service.price);
    });

    const total = values.reduce((a, v) => (a = a + v), 0);
    const formattedValue = getFormattedPrice(total);
    return formattedValue;
}